<template id="template">
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="css">
@import "./assets/css/typekit_fonts.css";
@import url("https://use.fontawesome.com/releases/v5.8.1/css/all.css");
#app {
  font-family: "eskorte-latin", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
